import { styled, Dialog, paperClasses, backdropClasses, IconButton, buttonClasses, Typography, DialogContent as DialogContent$1, DialogActions as DialogActions$1 } from "@mui/material";
import { SubmitButton as SubmitButton$1 } from "../../components/submit-button/submit-button.js";
import "react/jsx-runtime";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "lottie-react";
import "../../../../../components/loader/loader.styles.js";
import "./Button.js";
import "../../components/submit-button/submit-button.styles.js";
import "@mui/system";
const ModalDialog = styled(Dialog)(({ theme }) => ({
  userSelect: "none",
  [`& .${paperClasses.root}`]: {
    background: theme.palette.common.white,
    borderRadius: 20,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.13)",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  [`& .${backdropClasses.root}`]: {
    backgroundColor: "rgba(82, 82, 82, 0.3)"
  }
}));
const CloseButton = styled(IconButton)(({ theme }) => ({
  fontSize: 14,
  marginRight: theme.spacing(-1.5),
  marginTop: theme.spacing(-1.5),
  marginBottom: theme.spacing(-1.5),
  [`& .${buttonClasses.startIcon}`]: {
    color: "#636E79"
  }
}));
const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  textAlign: "center"
}));
const DialogContent = styled(DialogContent$1)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: 0,
  paddingBottom: 14
}));
const DialogHeader = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  marginBottom: theme.spacing(1.5),
  marginTop: theme.spacing(2),
  marginRight: theme.spacing(2)
}));
const DialogActions = styled(DialogActions$1)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(3)
}));
const HelperText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  color: theme.palette.grey[800]
}));
const SubmitButton = styled(SubmitButton$1)(() => ({
  margin: "0 auto"
}));
const Modal = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CloseButton,
  DialogActions,
  DialogContent,
  DialogHeader,
  HelperText,
  ModalDialog,
  SubmitButton,
  Title
}, Symbol.toStringTag, { value: "Module" }));
export {
  CloseButton,
  DialogActions,
  DialogContent,
  DialogHeader,
  HelperText,
  Modal as M,
  ModalDialog,
  SubmitButton,
  Title
};
